import React, { useState, useCallback } from 'react'
import { Form, FormGroup, FormFeedback, Label, Input } from 'reactstrap'
import _ from 'lodash'
import { ConfirmationFormData } from './types'
import {
  getValidationClassName,
  createFormChangeHandler,
} from './utils/formUtils'
import {
  FORM_NAMES,
  ASSIGNMENT_CONFIRMATION_MESSAGE,
  ASSIGNMENT_CONFIRMATION_CHECKBOX_TEXT,
} from './constants'
import { FormField, FormRow } from './components/FormComponents'

interface AssignConfirmProps {
  schoolName: string
  email: string
  onSelect: (data: ConfirmationFormData) => void
}

const AssignConfirm: React.FC<AssignConfirmProps> = ({
  schoolName,
  email,
  onSelect,
}) => {
  const [isConfirmed, setIsConfirmed] = useState(false)
  const [validation] = useState<Record<string, boolean>>({})

  const handleValueChange = useCallback(
    (name: string, value: any) => {
      if (name === 'isConfirmed') {
        setIsConfirmed(value as boolean)
        onSelect({
          isConfirmed: value as boolean,
        })
      }
    },
    [onSelect],
  )

  const handleChange = createFormChangeHandler(handleValueChange)
  const getClassName = useCallback(
    (id: string) => getValidationClassName(validation, id),
    [validation],
  )

  const schoolNameUE = _.unescape(schoolName)

  return (
    <Form name={FORM_NAMES.ASSIGN_CONFIRM} noValidate>
      <h4>Confirm Assignments</h4>
      <hr />
      <FormField label="Assigned School" value={schoolNameUE} readOnly={true} />
      <FormField label="License Administrator" value={email} readOnly={true} />
      <FormRow>
        <p>{ASSIGNMENT_CONFIRMATION_MESSAGE}</p>
      </FormRow>
      <FormGroup row>
        <Label sm={3}>{/* spacer */}</Label>
        <Label check sm={9} style={{ paddingLeft: '2rem' }}>
          <Input
            aria-required="true"
            checked={isConfirmed}
            className={getClassName('isConfirmed')}
            name="isConfirmed"
            onChange={handleChange}
            required
            type="checkbox"
          />
          {ASSIGNMENT_CONFIRMATION_CHECKBOX_TEXT}
        </Label>
        <FormFeedback tooltip>Please confirm.</FormFeedback>
      </FormGroup>
    </Form>
  )
}

export default AssignConfirm
